import uniqid from 'uniqid'

export default function generateId(prefix = 'c') {
	return uniqid(prefix)
}